import defaultSkin from './default';
import jivexSkin from './jivex';

const skins = {
  [defaultSkin.id]: defaultSkin,
  [jivexSkin.id]: jivexSkin,
};

export function getSkin(skinId) {
  return skins[skinId] || defaultSkin;
}

export function listSkins() {
  return Object.values(skins).map(({ id, label }) => ({ id, label }));
}

export default skins;
